import ServiceBase from '../../services/ServiceBase';
import strategyProxy from '../../proxies/strategy/StrategyProxy';

class RankingService extends ServiceBase {
  getDataRanking(params) {
    return this.applyMemoryCache('getRanking', params)(() =>
      strategyProxy.getRanking(params),
    );
  }
  getAllScore(params) {
    return this.applyMemoryCache('getAllScore', params)(() =>
      strategyProxy.getAllScore(params),
    );
  }

  getRateIndicator(params) {
    return this.applyMemoryCache('getRateIndicator', params)(() =>
      strategyProxy.getRateIndicator(params),
    );
  }

  downloadAllScore(params) {
    return this.applyMemoryCache('downloadAllScore', params)(() =>
      strategyProxy.downloadAllScore(params),
    );
  }

  downloadRanking(params) {
    return this.applyMemoryCache('downloadRanking', params)(() =>
      strategyProxy.downloadRanking(params),
    );
  }

  downloadIndicators(params) {
    return this.applyMemoryCache('downloadIndicators', params)(() =>
      strategyProxy.downloadIndicators(params),
    );
  }
}

const rankingService = new RankingService();
export default rankingService;
